import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './AppsList.scss'

import { List } from './'
import { AppCard } from '../AppCard'

const AppsList = ({ header, info, apps, footer, dark, noBorders }) => {
	apps =
		apps.length === 0
			? {
					shell1: {
						id: 'shell1',
						shell: true
					},
					shell2: {
						id: 'shell2',
						shell: true
					},
					shell3: {
						id: 'shell3',
						shell: true
					},
					shell4: {
						id: 'shell4',
						shell: true
					},
					shell5: {
						id: 'shell5',
						shell: true
					},
					shell6: {
						id: 'shell6',
						shell: true
					}
				}
			: apps
	return (
		<List
			header={header}
			noBorders={noBorders}
			info={info}
			body={
				<div className={styles.list}>
					{Object.keys(apps).map((app, i) => {
						const {
							id,
							category,
							name,
							shortDescription,
							status,
							iconUrl,
							shell,
							button,
							parent
						} = apps[app]

						return (
							<AppCard
								dark={dark}
								parent={parent}
								key={'app' + i + id + name}
								category={category}
								title={name}
								shortDescription={shortDescription}
								id={id}
								iconUrl={iconUrl}
								status={status}
								shell={shell}
								button={button}
							/>
						)
					})}
				</div>
			}
			footer={footer}
		/>
	)
}
AppsList.propTypes = {
	apps: React.PropTypes.oneOfType([
		React.PropTypes.array,
		React.PropTypes.object
	])
}

export default CSSModules(AppsList, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/AppsList.js